import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../shared/shared.module';
import {ESignatureRoutingModule} from '../e-signature/e-signature-routing.module';
import {DragulaModule} from 'ng2-dragula';
import {AdminRoutingModule} from './admin-routing.module';
import {SettingEtaxMenuComponent} from './setting-etax-menu/setting-etax-menu.component';
import {CompanyProfileComponent} from './company-profile/company-profile.component';
import {GroupCompanyComponent} from './group-company/group-company.component';
import {UserCompanyComponent} from './user-company/user-company.component';
import {AddUserCompanyComponent} from './add-user-company/add-user-company.component';
import {AddGroupCompanyComponent} from './add-group-company/add-group-company.component';
import {SetPasswordComponent} from './set-password/set-password.component';
import {CompanyListComponent} from './company-list/company-list.component';
import {SiteListComponent} from './site-list/site-list.component';
import { CreateSiteComponent } from './create-site/create-site.component';
import { AddSiteComponent } from './add-site/add-site.component';
import { WatermarkComponent } from './watermark/watermark.component';
import { AddToSiteComponent } from './add-to-site/add-to-site.component';
import { AddToGroupComponent } from './add-to-group/add-to-group.component';
import { UpdateQuotaComponent } from './update-quota/update-quota.component';
import { PackageListComponent } from './package-manager/package-list/package-list.component';
import { PackageDetailComponent } from './package-manager/package-detail/package-detail.component';
import { SearchFilterPipe } from './package-manager/search-filter.pipe';
import { PromotionListComponent } from './package-manager/promotion-list/promotion-list.component';
import { PromotionDetailComponent } from './package-manager/promotion-detail/promotion-detail.component';
import { ChangeCompanyLogoComponent } from './change-company-logo/change-company-logo.component';
import { PdfTemplateListComponent } from './pdf-template-list/pdf-template-list.component';
import {DmsModule} from "../dms/dms.module";
import {PdfTemplateListDialogComponent} from "./pdf-template-list-dialog/pdf-template-list-dialog.component";
import { PdfTemplateCreateDialogComponent } from './pdf-template-create-dialog/pdf-template-create-dialog.component';
import { DeletePdfTemplateComponent } from './delete-pdf-template/delete-pdf-template.component';
import { RenamePdfTemplateDialogComponent } from './rename-pdf-template-dialog/rename-pdf-template-dialog.component';
import { AllowIpComponent } from './allow-ip/allow-ip.component';
import { AllowIpDialogComponent } from './allow-ip/allow-ip-dialog.component';
import { AllowClientComponent } from './allow-client/allow-client.component';
import { AllowClientDialogComponent } from './allow-client/allow-client-dialog.component';


@NgModule({
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      SharedModule,
      ESignatureRoutingModule,
      AdminRoutingModule,
      DragulaModule.forRoot(),
      DmsModule,
   ],
    declarations: [
        SettingEtaxMenuComponent,
        GroupCompanyComponent,
        UserCompanyComponent,
        AddUserCompanyComponent,
        AddGroupCompanyComponent,
        SetPasswordComponent,
        CompanyProfileComponent,
        CompanyListComponent,
        SiteListComponent,
        CreateSiteComponent,
        AddSiteComponent,
        WatermarkComponent,
        AddToSiteComponent,
        AddToGroupComponent,
        UpdateQuotaComponent,
        PackageListComponent,
        PackageDetailComponent,
        PromotionListComponent,
        PromotionDetailComponent,
        ChangeCompanyLogoComponent,
        SearchFilterPipe,
        PdfTemplateListComponent,
        PdfTemplateListDialogComponent,
        PdfTemplateCreateDialogComponent,
        DeletePdfTemplateComponent,
        RenamePdfTemplateDialogComponent,
        AllowIpComponent,
        AllowIpDialogComponent,
        AllowClientComponent,
        AllowClientDialogComponent
    ]
})
export class AdminModule {
}
